module.exports = __webpack_public_path__ + "img/card-2.65305323.jpg";